<template>
  <div
    class="relative flex flex-row gap-4 rounded-xl bg-light-3 px-4 py-2 shadow dark:bg-dark-1"
  >
    <div class="flex min-w-16 flex-col justify-center text-center">
      <div>{{ floorName.split('-')[0] }}</div>
      <div style="font-weight: 700; font-size: 48px; line-height: 48px">
        {{ floorName !== 'EG' ? floorName.split('-')[1] : '-' }}
      </div>
    </div>

    <BuildingFloorRoomGroups
      :entrance="roomGroupData['entrance']"
      :roomgroups="roomGroupData['roomgroups']"
      :floor-name="floorName"
      :room-group-data-maps="roomGroupDataMaps"
      :is-on-site-inspection="isOnSiteInspection"
    />

    <div
      :data-testid="floorName + '_createRoomGroupButton'"
      class="my-1 flex min-w-20 items-center justify-center rounded-xl border-dark-4 bg-light-2 text-center text-3xl text-primary-2 shadow hover:bg-light-2 dark:border dark:bg-dark-3 hover:dark:bg-dark-4"
      @click="onAddRoomGroup"
    >
      <em class="mdi mdi-plus" />
    </div>

    <button
      v-if="isBuildingFloorDeletable"
      class="mdi mdi-close ml-auto flex justify-start text-2xl"
      data-testid="removeFloorButton"
      @click="deleteFloorLevel()"
    />
  </div>
</template>

<script lang="ts" setup>
import { floorLevelListMapping } from '@/enums/room';
import { Building, Roomgroup } from '@/models';
import { computed, inject } from 'vue';
import BuildingFloorRoomGroups from '@/components/BuildingOverview/BuildingFloorRoomGroups.vue';
import type {
  RoomGroupDataMaps,
  FloorHandlers,
} from '@/composables/useBuildingOverview';

const props = defineProps<{
  floorName: string;
  roomGroupData: any;
  currentBuilding: Building;
  isHighestFloorLevel: boolean;
  roomGroupDataMaps: RoomGroupDataMaps;
  isOnSiteInspection: boolean;
}>();

const floorHandlers = inject<FloorHandlers>('floorHandlers');

const isBuildingFloorDeletable = computed(() => {
  const entrance = props.roomGroupData['entrance'] as Roomgroup | undefined;
  if (!entrance) return false;

  const isEntranceEmpty =
    props.roomGroupDataMaps.isRoomgroupDeletable.get(entrance.id) ?? false;

  return Boolean(
    props.roomGroupData['roomgroups'].length === 0 &&
    props.floorName !== floorLevelListMapping.GROUND &&
    props.isHighestFloorLevel &&
    isEntranceEmpty
  );
});

const onAddRoomGroup = () => {
  const entranceId = props.roomGroupData['entrance']?.id;
  if (!entranceId || !floorHandlers) return;
  floorHandlers.addRoomgroup(entranceId);
};

const deleteFloorLevel = () => {
  const entrance = props.roomGroupData['entrance'] as Roomgroup;
  if (!entrance || !floorHandlers) return;
  floorHandlers.deleteFloor(entrance, props.floorName);
};
</script>
